document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".product-slider-block").forEach(function (sliderSection) {
    const swiperContainer = sliderSection.querySelector(".product-slider");
    if (!swiperContainer) return;

    const slidesPerView = parseInt(sliderSection.dataset.columns) || 3;
    const showArrows = sliderSection.dataset.showArrows === "true";

    new Swiper(swiperContainer, {
      loop: true,
      slidesPerView: slidesPerView,
      spaceBetween: 10,
      navigation: showArrows ? {
        nextEl: sliderSection.querySelector(".swiper-button-next"),
        prevEl: sliderSection.querySelector(".swiper-button-prev"),
      } : false,
      breakpoints: {
        0: {
          slidesPerView: 1.3,
        },
        768: {
          slidesPerView: slidesPerView,
        },
      },
    });
  });
});
